export default "__VITE_ASSET__feCFXuQY__"